import { render } from "./exchange-head.vue?vue&type=template&id=5880cf20&scoped=true&ts=true"
import script from "./exchange-head.vue?vue&type=script&lang=ts"
export * from "./exchange-head.vue?vue&type=script&lang=ts"

import "./exchange-head.vue?vue&type=style&index=0&id=5880cf20&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5880cf20"]])